import React, { useState } from 'react';

const ImageWithSkeleton = ({ src, alt, containerClass }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

 

  return (
    <div
      className={`relative rounded-[12px] overflow-hidden flex justify-center items-center min-w-[150px] min-h-[150px]`}
    >
      {/* Skeleton loader */}
      {(!loaded || error) && (
        <div
          className={`bg-gray-200 animate-pulse rounded-[12px] min-w-[350px] ${containerClass}`}
        />
      )}

      {/* Image */}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        className={` rounded-[12px] transition-opacity duration-300 min-w-[150px] min-h-[150px] max-h-[300px] ${
          loaded ? 'opacity-100' : 'opacity-0'
        }`}
        style={{
          objectFit: 'cover',
          boxShadow: '0px 0px 20px rgba(114, 116, 121, 0.25)',
        }}
      />
    </div>
  );
};

export default ImageWithSkeleton;
